var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableSortDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85425 9.875C8.02684 9.875 8.16675 9.73509 8.16675 9.5625V2.19194L10.1333 4.15847C10.2553 4.28051 10.4532 4.28051 10.5752 4.15847C10.6973 4.03643 10.6973 3.83857 10.5752 3.71653L8.07522 1.21653C7.95318 1.09449 7.75532 1.09449 7.63328 1.21653L5.13328 3.71653C5.01124 3.83857 5.01124 4.03643 5.13328 4.15847C5.25532 4.28051 5.45318 4.28051 5.57522 4.15847L7.54175 2.19194V9.5625C7.54175 9.73509 7.68166 9.875 7.85425 9.875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSortDesc);
export default __webpack_public_path__ + "static/media/table_sort_desc.da0285c6bb443061eaf037ff9456ce38.svg";
export { ForwardRef as ReactComponent };